import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { styled, alpha } from '@mui/material/styles';
import styles from "../../layout/material-dashboard-react/components/headerLinksStyle.js";
import classNames from "classnames";
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Poppers from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import useWindowSize from "app/hooks/useWindowSize.js";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import axios from 'axios';

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(1)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));

const useStyles = makeStyles(styles);

export default function NavBarSearch(props) {

    const { } = props;

    const menuId = 'primary-search-account-menu';

    const classes = useStyles();
    const windowSize = useWindowSize();

    const [searchResults, setSearchResults] = useState([{ ID: '0', Reference: 'Searching', DateAdded: '', ResultType: '' }]);
    const [openSearch, setOpenSearch] = useState(null);

    const handleClickSearch = (event) => {
        if (openSearch && openSearch.contains(event.target)) {
            setOpenSearch(null);
        } else {
            setOpenSearch(event.currentTarget);
        }
    };

    const handleCloseSearch = () => {
        setOpenSearch(null)
    }

    const handleOnClickSearch = (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        const formData = new FormData(form);

        const plainFormData = Object.fromEntries(formData.entries());
        const formDataJsonString = JSON.stringify(plainFormData);

        axios
            .post(
                `${process.env.REACT_APP_API_ENDPOINT}/api/search`,
                formDataJsonString
            )
            .then(function (response) {
                setSearchResults(response.data)
            })
            .catch(function (error) {
                console.log("Search results failed " + error);
            });
    };

    const renderTable = (searchResults) => {

        const handleChange = (ID, ResultType) => e => {
            if (ID !== 0) {
                if (ResultType === 'Quote') {
                    window.location.href = '/LeoSeaPortal/quotedetails?shipmentId=' + ID + '';
                }
                if (ResultType === 'Booking') {
                    window.location.href = '/LeoSeaPortal/bookingdetails?shipmentId=' + ID + '';
                }
            }
        };

        return (<table className='table' id="search" aria-labelledby="tabelLabel">
            <thead>
                <tr>
                    <th>Reference</th>
                    <th>Result Type</th>
                    <th>Date Added</th>
                </tr>
            </thead>
            <tbody>
                {searchResults.map(item =>
                    <tr className="searchRow" key={item.ID} onClick={handleChange(item.ID, item.ResultType)} >
                        <td>{item.Reference}</td>
                        <td>{item.ResultType}</td>
                        <td>{item.DateAdded}</td>
                    </tr>
                )}
            </tbody>
        </table>);
    }

    let contents = renderTable(searchResults);

    return (
        <div>
            <form onSubmit={handleOnClickSearch}>
                <Search>
                    <StyledInputBase
                        autoComplete="off"
                        placeholder="Search"
                        inputProps={{ 'aria-label': 'search', 'name': 'searchInput' }}
                        />
                        <IconButton
                        size="large"
                        edge="end"
                        aria-label="search"
                        aria-controls={menuId}
                        aria-haspopup="true"
                        onClick={handleClickSearch}
                        color="inherit"
                        justIcon round type="submit"
                        sx={{ marginRight: 1 }}
                        >
                            <SearchIcon />
                        </IconButton>
                    </Search>
            </form>
            <Poppers
                open={Boolean(openSearch)}
                anchorEl={openSearch}
                transition
                disablePortal
                className={
                    classNames({ [classes.popperClose]: !openSearch }) +
                    " " +
                    classes.popperNav
                }
                style={{
                    zIndex: '2'
                }}
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        id="search-menu-list-grow"
                        style={{
                            transformOrigin:
                                placement === "bottom" ? "center top" : "center bottom",
                            maxHeight: windowSize.height - 150,
                            minWidth: "300px",
                            overflowY: 'scroll',
                            backgroundColor: '#FFFFFF'
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleCloseSearch}>
                                {contents}
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Poppers>
        </div>
    );
}
